import * as types from './constants';

export const setTables = data => ({
  type: types.SET_TABLES,
  data
});

export const handleLoading = status => ({
  type: types.HANDLE_LOADING,
  status
});

export const handleCovenant = (status, typePrice, hasCovenant) => ({
  type: types.HANDLE_COVENANT,
  status,
  typePrice,
  hasCovenant
});

export const registerFieldChange = (field, value) => ({
  type: types.REGISTER_FIELD_CHANGE,
  field,
  value
});

export const addTimeRange = () => ({
  type: types.ADD_TIME_RANGE
});

export const removeTimeRange = id => ({
  type: types.REMOVE_TIME_RANGE,
  id
});

export const addSpecificTimeRange = () => ({
  type: types.ADD_SPECIFIC_TIME_RANGE
});

export const removeSpecificTimeRange = id => ({
  type: types.REMOVE_SPECIFIC_TIME_RANGE,
  id
});

export const setRemoveAndReplaceTable = table => ({
  type: types.SET_REMOVE_AND_REPLACE_TABLE,
  table
});

export const handleRemoveAndReplaceModalOpen = status => ({
  type: types.HANDLE_REMOVE_AND_REPLACE_MODAL_OPEN,
  status
});

export const handleUpdate = data => ({
  type: types.HANDLE_UPDATE,
  data
});

export const openSpecialForm = (checked, linkedTable) => ({
  type: types.OPEN_SPECIAL_FORM,
  checked,
  linkedTable
});

export const setLinkedTableName = name => ({
  type: types.SET_LINKED_TABLE_NAME,
  name
});

export const handleSpecialUpdate = data => ({
  type: types.HANDLE_SPECIAL_UPDATE,
  data
});

export const setCovenant = data => ({
  type: types.SET_COVENANT,
  data
});

export const clearCovenant = () => ({
  type: types.CLEAR_COVENANT
});

export const clearPriceTable = () => ({
  type: types.CLEAR_PRICE_TABLE
});